import React from 'react';
import { Link } from 'react-router-dom';

// Utils
import PageUrlsUtils from 'Shared/utils/PageUrls.utils';

// Components
import WpAvatar from 'Wpds/components/avatar/WpAvatar';
import WpIcon from 'Wpds/components/icon/WpIcon';

// Styles
import './UserCell.scss';

const UserCell = row => {
  const baseClassName = 'UserCell';
  const name = row['user_name'];
  return (
    <div className={baseClassName}>
      <Link
        className={`${baseClassName}__link`}
        to={PageUrlsUtils.makeUserProfilePageUrl(row['user_slug'])}
        onClick={e => e.stopPropagation()}
      >
        <WpAvatar avatar={row['user_avatar']} size="sm" />
        <span className={`${baseClassName}__name`}>{name}</span>
        <div className={`${baseClassName}__external-link`}>
          <WpIcon name="external-link" size="sm" />
        </div>
      </Link>
    </div>
  );
};

export default UserCell;
